import { defineMessages } from 'react-intl-next';

export const ghostTextMessages = defineMessages({
	controlPlaceholder: {
		id: 'quick-find.ghost-text.control',
		defaultMessage: 'Search',
		description: 'Default placeholder for control cohort',
	},
	default3PPlaceholder: {
		id: 'quick-find.ghost-text.default-3p',
		defaultMessage: 'Search across all your apps',
		description: 'Default placeholder for 3P cohort',
	},

	sainPlaceholder: {
		id: 'quick-find.ghost-text.sain',
		defaultMessage: 'Ask me anything or search...',
		description: 'AI-powered placeholder for SAIN cohort',
	},
	multipleThirdPartyPlaceholder: {
		id: 'quick-find.ghost-text.3p-multiple',
		defaultMessage: 'Search {firstPartyApp}, {thirdPartyApp1}, {thirdPartyApp2} and other apps',
		description: 'Multiple third-party search placeholder',
	},
	twoAppPlaceholder: {
		id: 'quick-find.ghost-text.two-apps',
		defaultMessage: 'Search {firstPartyApp}, {thirdPartyApp1} and other apps',
		description: 'Search placeholder for two apps',
	},
	mixedAppsPlaceholder: {
		id: 'quick-find.ghost-text.mixed-apps',
		defaultMessage: 'Search {currentApp}, {otherFirstPartyApp}, {thirdPartyApp} and other apps',
		description: 'Search placeholder for current app, another 1P app, and a 3P app',
	},
	// Third-party product specific messages
	googleDrivePlaceholder: {
		id: 'quick-find.ghost-text.3p.google-drive',
		defaultMessage: 'Search your Google Drive Docs, Sheets and Slides',
		description: 'Ghost text placeholder for Google Drive search',
	},
	sharepointPlaceholder: {
		id: 'quick-find.ghost-text.3p.sharepoint',
		defaultMessage: 'Search your SharePoint documents and files',
		description: 'Ghost text placeholder for SharePoint search',
	},
	onedrivePlaceholder: {
		id: 'quick-find.ghost-text.3p.onedrive',
		defaultMessage: 'Search your OneDrive documents and files',
		description: 'Ghost text placeholder for OneDrive search',
	},
	teamsPlaceholder: {
		id: 'quick-find.ghost-text.3p.teams',
		defaultMessage: 'Search your Microsoft Teams chats and messages',
		description: 'Ghost text placeholder for Microsoft Teams search',
	},
	slackPlaceholder: {
		id: 'quick-find.ghost-text.3p.slack',
		defaultMessage: 'Search your Slack DMs and messages',
		description: 'Ghost text placeholder for Slack search',
	},
	githubPlaceholder: {
		id: 'quick-find.ghost-text.3p.github',
		defaultMessage: 'Search your GitHub repos, commits and PRs',
		description: 'Ghost text placeholder for GitHub search',
	},
	// SAIN cohort question suggestions
	sainQuestionTimeOff: {
		id: 'quick-find.ghost-text.sain.time-off',
		defaultMessage: 'Try any question, like "How do I request time off"',
		description: 'SAIN ghost text suggestion for time off question',
	},
	sainQuestionResetPassword: {
		id: 'quick-find.ghost-text.sain.reset-password',
		defaultMessage: "Try any question, like 'How do I reset my password?'",
		description: 'SAIN ghost text suggestion for password reset question',
	},
	sainQuestionNotifications: {
		id: 'quick-find.ghost-text.sain.notifications',
		defaultMessage: 'Try any question, like "How do I change my notification settings?"',
		description: 'SAIN ghost text suggestion for notification settings question',
	},
	sainQuestionITSupport: {
		id: 'quick-find.ghost-text.sain.it-support',
		defaultMessage: 'Try any question, like "How do I contact IT support?"',
		description: 'SAIN ghost text suggestion for IT support question',
	},
	sainQuestionMeetingRoom: {
		id: 'quick-find.ghost-text.sain.meeting-room',
		defaultMessage: 'Try any question, like "How do I book a meeting room?"',
		description: 'SAIN ghost text suggestion for meeting room booking question',
	},
	sainQuestionBenefits: {
		id: 'quick-find.ghost-text.sain.benefits',
		defaultMessage: "Try any question, like 'Where can I see my benefits?'",
		description: 'SAIN ghost text suggestion for benefits question',
	},
});
